<template>
  <div class="flex flex-col min-h-screen pt-200">
    <div class="w-full h-600" />

    <main v-bind="$attrs" class="content-wrap flex-1 w-full px-100">
      <slot />
    </main>
  </div>
</template>
